import * as zod from 'zod';

export const EquipmentConfig = zod
  .object({
    kind: zod.string(),
    name: zod.string().optional(),
  })
  .passthrough();

export const EquipmentData = zod.object({
  createdAt: zod.string().optional(),
  updatedAt: zod.string().optional(),
  id: zod.string(),
  config: EquipmentConfig,
  isEnabled: zod.boolean(),
  simulatorPort: zod.number().optional(),
});

export type EquipmentData = zod.infer<typeof EquipmentData>;
